import React, { useEffect, useRef, useState, useContext } from 'react'
import {
  Typography,
  Grid,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  DialogActions,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import { Skeleton } from '@material-ui/lab';
import { useTranslation } from "react-i18next";
import { commonService } from "../../services/common.service";
import { TabsContext } from "./dataRefresh"
const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    background: theme.palette.ePrimary?.base,
    color: theme.palette.eWhite?.base,
    paddingLeft: "3%",
  },
  rightIcon: {
    textAlign: "-webkit-right",
  },
  closeIcon: {
    color: theme.palette.eWhite?.base,
  },
  buttonStyle: {
    borderRadius: 20,
    padding: "1% 5%",
    background: theme.palette.ePrimary?.base,
    color: theme.palette.eWhite?.base,
    "&:hover": {
      backgroundColor: theme.palette.ePrimary?.hover,
    },
    "&:focus": {
      border: "4px solid" + theme.palette.ePastelColor2?.base
    },
  },
  dialogContent: {
    color: theme.palette.eDark?.base + "!important"
  },
  alertIcon: {
    color: theme.palette.eTertiary?.base,
    width: "4rem",
    height: "auto",
    display: "block",
    margin: "auto",

  },
  dialogContainer: {
    ["@media (min-width:393px)"]: {
      maxWidth: "90% !important"
    },
    ["@media (min-width:768px)"]: {
      maxWidth: "60% !important"
    },
    ["@media (min-width:1024px)"]: {
      maxWidth: "40% !important"
    },
  }, paper: {
    position: 'absolute',
    width: 500,
    fontSize: "16px !important",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  link: {
    color: theme.palette.ePrimary?.base + "!important",
    textDecoration: "underline !important",
    "&:hover": {
      color: theme.palette.ePrimary?.hover + "!important",
    },
  },
  customer: {
    fontWeight: "bold",
  },
  icon: {
    padding: "0px !important",
  }
}))

export default function SimpleModal(props) {
  const { setlocalStorageupdate } = useContext(TabsContext)
  const style = useStyles()
  const [open, setOpen] = useState(false);
  const { t: labelok, ready: labelreadyok } = useTranslation("label-E_CONFIRMATION_SCREEN");
  const { t: labels, ready: labelReadys } = useTranslation("label-E_HEADER");
  const { t: label, ready: labelReady } = useTranslation("label-PROFILE_MANAGMENT");
  const { t: content, ready: contentReady } = useTranslation("content-PROFILE_MANAGMENT");
  let accountSelected = localStorage.getItem("accountSelected")
  useEffect(() => {
    props.open ? setOpen(true) : setOpen(false)
  }, [props])
  const handleClose = () => {
    setOpen(false);
    setlocalStorageupdate(true)
  };
  const logout = () => {
    commonService.logoutUser();
  }
  return (

    <Dialog
      disableBackdropClick
      style={{ paperWidthSm: style.dialogContainer }}
      open={open}
      PaperProps={{
        style: { borderRadius: 10 }
      }}
      onClose={handleClose}
      fullWidth={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Grid
        container
        alignItems="center"
        className={style.dialogTitle}
        justify="space-between"
      >
        <Grid item xs={10}>
          <Typography variant="subtitle1">
            {labelReady ? label("E_ACCOUNT_CLOSER_INFO") : <Skeleton />}
          </Typography>
        </Grid>
        <Grid item xs={2} className={style.rightIcon}>
          <IconButton aria-label="close"
            onClick={props.selectedacc ? logout : handleClose}
          >
            <CloseIcon className={style.closeIcon} />
          </IconButton>
        </Grid>
      </Grid>
      <DialogContent dividers>
        <Grid container>
          <Grid item xs={12}>
            <WarningRoundedIcon className={style.alertIcon} />
          </Grid>
          <Grid item xs={12}>
            {props.selectedacc ? (contentReady ? <Typography
              variant="body1"
              className={style.dialogContent}
              dangerouslySetInnerHTML={{
                __html: content("E_ACCOUNT_CLOSER_POP").answer?.replace("*class*", style.link).replace("*class1*", style.link).replace("*class2*", style.link).replace("&customer&", accountSelected)
              }}>
            </Typography> : <Skeleton />) : (contentReady ? <Typography variant="body1" className={style.dialogContent}>{content("E_ACCOUNT_CLOSER_POP2").answer?.replace("&customer&", props.delaccount)}</Typography> : <Skeleton />)}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        {props.selectedacc ? <Button
          onClick={logout}
          variant="contained"
          size="small"
          className={style.buttonStyle}
          align="right"
        >
          <Typography variant='button'>
            {labelReadys ? labels("E_HEADER_LOGOUT") : <Skeleton />}
          </Typography>
        </Button>
          :
          <Button
            onClick={handleClose}
            variant="contained"
            size="small"
            className={style.buttonStyle}
            align="right"
          >
            <Typography variant='button'>
              {labelreadyok ? labelok("E_CONFIRMATION_OK") : <Skeleton />}
            </Typography>
          </Button>}
      </DialogActions>
    </Dialog>
  );
}
